import { render, staticRenderFns } from "./OrderColportajeModalComponent.vue?vue&type=template&id=a830c57a&scoped=true&"
import script from "./OrderColportajeModalComponent.vue?vue&type=script&lang=js&"
export * from "./OrderColportajeModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./OrderColportajeModalComponent.vue?vue&type=style&index=0&id=a830c57a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a830c57a",
  null
  
)

export default component.exports